import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BazisFormService } from '@bazis/form/services/form.service';
import { SharedModule } from '@shared/shared.module';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { MapModule } from '@map/map.module';

import { BazisFormModule } from '@bazis/form/form.module';
import { InputOptionsButtonComponent } from '@form/components/input-options-button.component';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { GhostInputDefaultComponent } from '@form/components/ghost-input-default.component';
import { MenuInputDateintervalComponent } from '@form/components/menu-input-date-interval.component';
import { AutocompleteInsideComponent } from '@form/components/autocomplete-inside.component';
import { InfiniteListComponent } from '@bazis/shared/components/infinite-list.component';
import { OrganizationPipe } from '@bazis/shared/pipes/organization.pipe';
import { AutocompleteStaticInsideComponent } from '@form/components/autocomplete-static-inside.component';
import { SearchFieldExpandedComponent } from '@form/components/search-field-expanded.component';
import { InputOptionsChipComponent } from '@form/components/input-options-chip.component';
import { AppInputContactsComponent } from '@form/components/input-contacts.component';
import { AppInputPointComponent } from '@form/components/input-point.component';
import { AppInputFileComponent } from '@form/components/input-file.component';
import { BazisSharedModule } from '@bazis/shared/shared.module';
import { AppFileInlineComponent } from '@pages/shared/components/file-inline/file-inline.component';
import { ButtonTooltipComponent } from '@pages/shared/components/button-tooltip/button-tooltip.component';
import { AppEditEntityDefaultComponent } from '@form/helper-components/edit-entity-default.component';
import { AppNewPasswordComponent } from '@form/components/input-new-password.component';
import { AppAutocompleteMultipleComponent } from '@app/form/components/autocomplete-multiple.component';
import { NgxMaskDirective } from 'ngx-mask';
import { MultipleSelectionInfiniteListComponent } from '@form/control-part-components/multiple-selection-infinite-list.component';
import { AppInputScheduleComponent } from '@form/components/input-schedule.component';
import { SelectWithTagsComponent } from '@form/components/select-with-tags.component';
import { AppInputFileButtonComponent } from '@form/components/input-file-button.component';
import { InputSymbolComponent } from '@form/components/input-symbol.component';
import { InputTinOrganizationComponent } from '@form/components/input-tin-organization.component';

const DECLARATIONS = [
    InputOptionsButtonComponent,
    InputOptionsChipComponent,
    GhostInputDefaultComponent,
    MenuInputDateintervalComponent,
    AutocompleteInsideComponent,
    AutocompleteStaticInsideComponent,
    SearchFieldExpandedComponent,
    AppInputContactsComponent,
    AppInputPointComponent,
    AppInputFileComponent,
    AppEditEntityDefaultComponent,
    AppNewPasswordComponent,
    AppAutocompleteMultipleComponent,
    MultipleSelectionInfiniteListComponent,
    AppInputScheduleComponent,
    SelectWithTagsComponent,
    AppInputFileButtonComponent,
    InputSymbolComponent,
    InputTinOrganizationComponent,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        MapModule,
        TranslocoModule,
        BazisFormModule,
        BazisSharedModule,

        ColorDirective,
        InfiniteListComponent,
        OrganizationPipe,
        AppFileInlineComponent,
        ButtonTooltipComponent,
        NgxMaskDirective,
    ],
    exports: [BazisFormModule, ...DECLARATIONS],
    declarations: [...DECLARATIONS],
    providers: [BazisFormService, { provide: TRANSLOCO_SCOPE, useValue: ['form'] }],
})
export class FormModule {}
